import React from 'react'
import PropTypes from 'prop-types'

export default class CloudinaryURLProvider extends React.Component {
  static childContextTypes = {
    cloudinaryURL: PropTypes.string,
  }

  getChildContext() {
    return {
      cloudinaryURL:
        process.env.NODE_ENV == 'production'
          ? 'https://assets.visioncritical.net/image'
          : 'https://qa-assets.visioncritical.net/image',
    }
  }

  render() {
    return this.props.children
  }
}
